export function encode(item) {
  const stringifiedObject = JSON.stringify(item);
  const base64String = btoa(stringifiedObject);
  const encodedString = encodeURIComponent(base64String);

  return encodedString;
}

export function decode(string) {
  const decodedString = decodeURIComponent(string);
  const stringifiedObject = atob(decodedString);
  const item = JSON.parse(stringifiedObject);

  return item;
}
